<template>
  <div>
    <cc-form
      :config="formConfig"
      v-model="form"
      ref="createDiscountProduct"
      labelWidth="110px"
      :rules="goodsRules"
      size="medium"
    ></cc-form>
    <el-button type="primary" size="medium" @click="save">確定</el-button>
  </div>
</template>
<script>
import goods from "./selectGoods.vue";

export default {
  data() {
    let checkSalePrice = (rule, value, callback) => {
      value += "";
      if (value) {
        if (value.indexOf(".") > -1) {
          callback(new Error(this.language("scrapProducts.onlyintegers")));
        } else if (value < 0) {
          callback(new Error(this.language("scrapProducts.onlyintegers")));
        }
        callback();
      } else {
        callback(new Error(this.language("scrapProducts.onlyintegers")));
      }
    };
    return {
      formConfig: {
        props: [
          //   {
          //     label: "Products",
          //     name: "categories",
          //     type: "input",
          //   },
          {
            name: "productNum",
            type: "component",
            componentName: goods,
            label: "Products",
          },
          {
            name: "salePrice",
            type: "number",
            label: "SalePrice",
          },
        ],
      },
      form: {},
      goodsRules: {
        productNum: [
          {
            required: true,
            message: this.language("scrapProducts.productNumRules"),
            trigger: "blur",
          },
        ],
        salePrice: [
          {
            required: true,
            message: this.language("scrapProducts.salePriceRules"),
            trigger: "blur",
          },
          { validator: checkSalePrice, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    save() {
      this.$refs["createDiscountProduct"]
        .validate()
        .then(() => {
          let form = { ...this.form };
          form.price = form.salePrice * 100;
          form.shopNum=this.$shopData.shopNum
          this.ccRequest
            .do("admin/merchant/product/createDiscountProduct", form, "GET")
            .then((res) => {
              this.$alert("待「一本」批核", "提示", {
                confirmButtonText: "確認",
                callback: (action) => {
                  this.$emit("success", true);
                  this.$message.success(this.language("scrapProducts.success"));
                },
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>